import { Length, IsEmail } from 'class-validator';

export class InitResetPasswordModel {
  @Length(2, 64)
  @IsEmail()
  public email: string;

  constructor(
    email: string,
  ) {
    this.email = email;
  }
}
